import React from "react";
import FooterMain from "./FooterMain";

const FooterMainContainer = React.memo(({...props }) => {
  return <FooterMain {...props } />;
});

export default FooterMainContainer;
